import React, { ReactNode } from 'react';
import clsx from 'clsx'
import { useLayout } from '../core'

interface ContentProps {
  children: ReactNode;
}

const Content: React.FC<ContentProps> = ({ children }) => {
  const { classes } = useLayout()

  return (
    <div id='kt_content_container' className={clsx(classes.contentContainer.join(' '))}>
      {children}
    </div>
  )
}

export { Content }
